import React, { Fragment, useState, useLayoutEffect } from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router-dom";

import { useIsMounted } from "../../utils/hooks";

interface OutletContextI {
	postLogoutRedirectUri?: string;
	displaySignoutPrompt: boolean;
	signOutIframeUrl?: string;
	logoutId?: string;
	token: {
		header: string;
		value: string;
	};
}

export const LogoutForm = () => {
	const context = useOutletContext<OutletContextI>();
	const { formatMessage } = useIntl();
	const [showLoading, toggleShowLoading] = useState(true);
	const isMounted = useIsMounted();

	useLayoutEffect(() => {
		setTimeout(() => {
			if (context.postLogoutRedirectUri) {
				window.location.href = context.postLogoutRedirectUri;
			} else {
				isMounted() && toggleShowLoading(false);
			}
		}, 0);
	}, [isMounted, context.postLogoutRedirectUri]);

	return (
		<div className="form-wrapper">
			{context.displaySignoutPrompt ? (
				<section className="form-section">
					<h1>{formatMessage({ id: "komid.loggedout.wouldyoulogout" })}</h1>
					<form data-hj-suppress action="/requestlogout" method="post">
						<fieldset>
							<input
								type="hidden"
								name="logoutId"
								value={context.logoutId || ""}
							/>
							<input
								type="hidden"
								name={`__${context.token.header}`}
								value={context.token.value}
							/>
							<div className="form-group">
								<button
									className="button primary"
									data-testid="logout-btn"
									type="submit"
								>
									{formatMessage({ id: "komid.loggedout.yes" })}
								</button>
							</div>
						</fieldset>
					</form>
				</section>
			) : (
				<>
					<div className="loggedout-page">
						{showLoading ? (
							<div className="row logging-out">
								<div className="throbber" data-testid="spinner">
									<svg className="circular">
										<circle className="path" cx="15" cy="15" r="12" />
									</svg>
								</div>
								<p>{formatMessage({ id: "komid.loggedout.loggingout" })}</p>
							</div>
						) : (
							<section key="logout" className="form-section">
								<div className="row logged-out">
									<span className="icon-xl green-check-circle-dark"></span>
									<p>
										{formatMessage({ id: "komid.loggedout.youareloggedout" })}
									</p>
								</div>
							</section>
						)}
					</div>
					{context.signOutIframeUrl && (
						<div
							dangerouslySetInnerHTML={{
								__html: `<iframe style="display: none"
									title="signOutIframe"
									width="0"
									height="0"
									className="signout"
									data-testid="signOutIframe"
									id="signout"
									src="${context.signOutIframeUrl}" />`,
							}}
						/>
					)}
				</>
			)}
		</div>
	);
};
